// extracted by mini-css-extract-plugin
export default {"button":"button_button__V37Iu","xlarge":"button_xlarge__wIOuA"};